export var AmplitudeEventKeys;
(function (AmplitudeEventKeys) {
    AmplitudeEventKeys["ClickSlippingAwayReport"] = "CLICK-SLIPPING-AWAY-REPORT";
    AmplitudeEventKeys["ClickVisitorReport"] = "CLICK-VISITOR-REPORT";
    AmplitudeEventKeys["ClickChurnedReport"] = "CLICK-CHURN-REPORT";
})(AmplitudeEventKeys || (AmplitudeEventKeys = {}));
export var AmplitudeVariantValue;
(function (AmplitudeVariantValue) {
    AmplitudeVariantValue["OFF"] = "off";
    AmplitudeVariantValue["CONTROL"] = "control";
    AmplitudeVariantValue["A"] = "a";
    AmplitudeVariantValue["B"] = "b";
    AmplitudeVariantValue["C"] = "c";
})(AmplitudeVariantValue || (AmplitudeVariantValue = {}));
// Key needs to be lowercase only
export var AmplitudeFlagKey;
(function (AmplitudeFlagKey) {
    AmplitudeFlagKey["NpoStarterBanking"] = "npo-starter-banking";
    AmplitudeFlagKey["IsImportMailchimpActive"] = "is-mailchimp-import-active";
    AmplitudeFlagKey["LiveFormP2p"] = "live-form-p2p";
    AmplitudeFlagKey["NewPermissionExperience"] = "new-permission-experience";
    AmplitudeFlagKey["LivePeerCredChip"] = "live-peer-cred-chip";
    AmplitudeFlagKey["LivePeerCredChipTicketsLeft"] = "live-peer-cred-chip-tickets-left";
    AmplitudeFlagKey["ImprovedStripeVerificationUS"] = "improved-stripe-verification-us";
    AmplitudeFlagKey["FormsUnsupportedBrowserRedirection"] = "forms-unsupported-browser-redirection";
    AmplitudeFlagKey["EasierDonorRefund"] = "easier-donor-refund";
    AmplitudeFlagKey["RegisterPageSplitScreenV2"] = "register-page-split-screen-v2";
    AmplitudeFlagKey["PostMail"] = "post-mail";
    AmplitudeFlagKey["DelayedSignUp"] = "delayed-sign-up";
    AmplitudeFlagKey["QuestionFilterOnGuestList"] = "question-filter-on-guest-list";
    AmplitudeFlagKey["CentralizedAICopyAssistant"] = "centralized-ai-copy-assistant";
})(AmplitudeFlagKey || (AmplitudeFlagKey = {}));
